import { useRef } from "react";
import { useGSAP } from "@gsap/react";
import gsap from "gsap"; // Import GSAP's useGSAP hook

interface ButtonItem {
  icon: React.ReactNode;
}

interface SlideToggleProps {
  buttonArray: ButtonItem[];
  handleClick: (value: number) => void;
  currentIndex: number;
}

const SlideToggle: React.FC<SlideToggleProps> = ({
  buttonArray,
  handleClick,
  currentIndex,
}) => {
  const componentRef = useRef<HTMLDivElement | null>(null);

  // Initialize GSAP animation using the useGSAP hook
  useGSAP(() => {
    if (!componentRef.current) return;

    // GSAP animation logic
    const slideMarker = componentRef.current.querySelector(".slide-marker");

    // Ensure the element is found
    if (slideMarker) {
      gsap.to(slideMarker, {
        x: currentIndex * 40, // Move the slide marker based on the index
        ease: "back.inOut(1.7)",
        duration: 0.8,
      });
    }
  }, [currentIndex]); // Trigger animation whenever `currentIndex` changes

  return (
    <div className="relative border border-white/30 rounded-lg p-2" ref={componentRef}>
      <div className="slide-marker w-[30px] h-[30px] absolute bg-white/10 top-2 left-2 pointer-events-none rounded-lg"></div>
      <div className="flex space-x-[10px]">
        {buttonArray.map((el, index) => (
          <button
            key={index}
            className="w-[30px] h-[30px] flex justify-center items-center text-white cursor-pointer rounded-lg hover:bg-white/10 transition-colors duration-200"
            onClick={() => handleClick(index)}
          >
            {el.icon}
          </button>
        ))}
      </div>
    </div>
  );
};

export default SlideToggle;
